<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="任务转让"
        width="650px"
        append-to-body
        top="10vh"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" class="pr50">
                <el-form-item label="接收人：" prop="user_id">
                    <el-select
                        ref="searchInput"
                        v-model="formItem.user_id"
                        filterable
                        remote
                        clearable
                        :remote-method="getUserList"
                        :loading="searchLoading"
                        class="full-w"
                        placeholder="输入成员名称关键字搜索成员">
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <p class="text-color-gray font12px mt4">转让表示将所选任务转至接收人，转让后当前归属人将无法查看与操作</p>
                </el-form-item>
            </el-form>
            <ErrTipModal ref="errTipModal" />
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn">转让</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import API from '@/api/efficiencyTool/task.js';
    import ErrTipModal from '../../../modal/errorTipModal';

    export default {
        name: "PushModal",
        components:{
            ErrTipModal,
        },
        props:{
            data:Array,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    user_id:'',
                },
                submitLoading:false,
                rules:{
                    user_id:[
                        { required: true, message: '请选择接收人', trigger: 'blur' },
                    ],
                },
                userList:[],
                searchLoading:false,
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.formItem.user_id= '';
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
                this.getUserList();
            },
            getUserList(query){
                if (query !== '') {
                    this.searchLoading = true;
                    API.getPushUserList({
                        search: query,
                    }).then(res => {
                        this.userList = res.data || [];
                        this.searchLoading = false;
                    }, (err) => {
                        console.log('getUserList error', err);
                        this.userList = [];
                        this.searchLoading = false;
                    });
                } else {
                    this.userList = [];
                }
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let taskIds = this.data.map(item=>item.task_id);
                        this.submitLoading = true;
                       API.pushTask({
                           user_id:this.formItem.user_id,
                           task_ids:taskIds.join(','),
                       }).then(res=>{
                           this.submitLoading = false;
                           this.$message.success(res.info||'操作成功');
                           this.handleClose();
                           this.$emit('update');
                       },err=>{
                           console.log('setTaskPos err',err);

                           let errData = err.data||{};
                           let errList = errData.error_auth||[];
                           if(err.code==403){
                               return this.$message.error(err.info||'请求异常');
                           }
                           if(errList.length>0){
                               this.$refs.errTipModal.showModal({
                                   title:err.info||'接收人无以下账户权限，无法转让',
                                   subTitle:'',
                                   actionType:'pushTask',
                                   isConfirm:false,
                                   errList:errList,
                                   actionData:'',
                               });
                           }else{
                               this.$message.error(err.info||'操作失败');
                           }


                           this.submitLoading = false;
                       });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
    }
</style>
